import { ActionContext, ActionTree } from 'vuex';
import { RelayState } from '@/store/modules/relay/relayState';
import { RootState } from '@/store/rootState';
import axios from 'axios';
import { RelayConnection } from '@/core/interfaces/relayConnection';
import { RelayMachine } from '@/core/interfaces/relayMachine';
import { Vehicle } from '@/core/interfaces/vehicle';
import arrayUnique from 'array-unique';

const actions: ActionTree<RelayState, RootState> = {
    syncAllServers: async(context: ActionContext<RelayState, RootState>) => {
        const vehicles = context.rootGetters.vehiclesSet as Vehicle[];
        const relayServers = arrayUnique(vehicles.map(vehicle => vehicle.relay_server_hostname));

        return await Promise.all(relayServers.map(server => context.dispatch('syncRelayServer', server)));
    },

    syncRelayServer: async(context: ActionContext<RelayState, RootState>, server: string) => {
        const connectionsResponse = axios.get<RelayConnection[]>(`https://${server}.next.lely.cloud/api/info/connections`);
        const machinesResponse = axios.get<RelayMachine[]>(`https://${server}.next.lely.cloud/api/info/machines`);

        const [connections, machines] = (await Promise.all([connectionsResponse, machinesResponse])).map(data => data.data);

        context.commit('addRelayServer', {
            server,
            connections,
            machines,
        });
    },

    resetStatsForActiveServer: async(context: ActionContext<RelayState, RootState>) => {
        await axios.post(`https://${context.state.activeServer}.next.lely.cloud/api/info/reset`);

        await context.dispatch('syncRelayServer', context.state.activeServer);
    },
};

export default actions;
